export default __webpack_public_path__ + "static/media/CAT.e135088a.wav";